import * as React from "react";
import {useState, useEffect} from "react";
import { jfetch } from "../../utils";
import { toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";
import { ResponsivePie } from '@nivo/pie'

function PollsQuestion(props) {

  let data2 = []
  props.voteResults.forEach(element => {
    data2.push(
      {
        id:element.name,
        label: element.name,
        value: element.votes
      }
    )
  });

  const sendReport = () => {
    jfetch.get(`/poll/questions/${props.pollQuestion.id}/send_report`)
    .then((resp) => {
      toast.success('report was sent')
    })
    .catch((err) => {
      toast.error('error sending report')
    })
  }

      return (
        <PageContainer>
          <ModernCard ta="left">
            <div>
              <h1 style={{color:'black'}}>{props.pollQuestion.info}</h1>
              <h3 style={{color:'black'}}> options: 
                {props.voteResults.map((choice) => ` ${choice.name}, `)}
              </h3>
              <h3 style={{color:'black'}}>active: {props.pollQuestion.active ? 'yes' : 'no'}</h3>
              <h3 style={{color:'black'}}>total votes: {props.voteCount}</h3>
            </div>
            <div style={{height:'500px'}}>
              <ResponsivePie
                data={data2}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                borderWidth={1}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
              />
        </div>
        <div>
          <button className="btn btn-primary" onClick={sendReport}>Send Teams Report</button>
        </div>
      </ModernCard>
      <ModernCard ta="left">
            <div>
              <h1 style={{color:'black'}}>voters</h1>
            </div>
            <div>
              {props.voters.map((voter) => {
                return (
                  <div key={voter.email} style={{color:'black'}}>
                    <a href={`/employees/${voter.userId}`}>{voter.name}</a>
                    &lt;{voter.email}&gt; - {voter.choice}
                  </div>
                )
              })}
        </div>
      </ModernCard>      
    </PageContainer>
  );
}

export default PollsQuestion;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/PollsQuestion.tsx